import classNames from 'classnames'

type DesktopDropdownMenuProps = {
  readonly title: string
  readonly showDropdown: boolean
  readonly sideNav: boolean
  readonly baseClassNames: string
  readonly dataTestId?: string
  readonly children: React.ReactNode
}

function getTransitionClass(sideNav: boolean) {
  return sideNav ? '' : 'transition-[transform,opacity] duration-150'
}

function getPositionClass(showDropdown: boolean, sideNav: boolean) {
  if (!sideNav) {
    return showDropdown
      ? 'translate-y-0 opacity-100'
      : 'pointer-events-none -translate-y-3 opacity-0'
  }
}

function getVisibilityClass(showDropdown: boolean) {
  return showDropdown ? 'block' : 'hidden'
}

function getDropdownMenuClassName(
  baseClassNames: string,
  showDropdown: boolean,
  sideNav: boolean
) {
  return classNames(
    baseClassNames,
    getTransitionClass(sideNav),
    getPositionClass(showDropdown, sideNav),
    getVisibilityClass(showDropdown)
  )
}

export function DesktopDropdownMenu({
  title,
  showDropdown,
  sideNav,
  baseClassNames,
  dataTestId,
  children
}: DesktopDropdownMenuProps) {
  return (
    <div
      id={title}
      aria-hidden={!showDropdown}
      className={getDropdownMenuClassName(
        baseClassNames,
        showDropdown,
        sideNav
      )}
      data-testid={dataTestId}
    >
      {children}
    </div>
  )
}
